










import { Vue, Component } from 'vue-property-decorator';
import RegisterAdminCard from '@/components/public/RegisterAdminCard.vue';
import { eventBus } from '../../main';
import { REGISTER_ADMIN, SHOW_SNACKBAR } from '../../common/constants';
import { ADMIN_BRAND_ASSETS, LOGIN_PAGE } from '../../common/routes.config';
import brandModule from '../../store/modules/brand.module';

@Component({
  components: {
    RegisterAdminCard,
  },
})
export default class RegisterAdmin extends Vue {
  created(): void {
    // If brandId is not set in params, redirect to login and show error.
    if (!this.$router.currentRoute.params.adminId) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'Invalid registration invite. Please have the admin resend invitation',
      );
      this.$router.push(LOGIN_PAGE);
      return;
    }
    // RegisterAdminCard emits REGISTER_ADMIN when registration was successful
    eventBus.$on(REGISTER_ADMIN, this.registrationCompleted);
  }

  /**
   * Registeration was successful, send admin to portal.
   */
  async registrationCompleted(): Promise<void> {
    setTimeout(() => {
      this.cueConfetti();
      if (!brandModule.brand) { return; }
      this.$router.push({ ...ADMIN_BRAND_ASSETS, params: { brandId: brandModule.brand.id } });
    }, 2500);
  }

  cueConfetti(): void {
    const vueInstance = this as any;
    vueInstance.$confetti.start();
    setTimeout(() => {
      vueInstance.$confetti.stop();
    }, 4000);
  }
}
